$(document).ready(function () {
  if ($("#payment-preference-toggle").length > 0) {
    setPaymentToggleState();
  }
});

function setPaymentToggleState() {
  const paymentPeriod = localStorage.getItem("paymentPeriod");

  if (paymentPeriod === null) {
    return;
  }

  const isAnnual = paymentPeriod === '"annual"';
  $("#payment-preference-toggle").prop("checked", isAnnual);
  toggleOptions();
}

function toggleSection() {
  const buttonElement = $(this);

  if (buttonElement.hasClass("logo")) {
    return;
  }

  toggleDocumentsSection(buttonElement);
}

function toggleDocumentsSection(buttonElement) {
  const documentCollapsed = buttonElement.parent().next();
  const document = documentCollapsed.next();
  const documentContainer = documentCollapsed.parent().parent();

  $(".documents-and-endorsements .document").addClass("hidden");
  $(".document-collapsed").removeClass("hidden");
  $(".document-accordion").removeClass("hidden");
  $(".document-container").removeClass("focus");

  buttonElement.addClass("hidden");
  document.toggleClass("hidden");
  documentCollapsed.toggleClass("hidden");
  documentContainer.toggleClass("focus");
}

function togglePaymentOptions(containerName, premium = "") {
  const $annual = $(
    ".".concat(containerName, "-container .payment-option", premium, "-annual"),
  );
  const $annualTablet = $(
    ".".concat(
      containerName,
      "-container .payment-option",
      premium,
      "-annual-tablet",
    ),
  );
  const $monthly = $(
    ".".concat(
      containerName,
      "-container .payment-option",
      premium,
      "-monthly",
    ),
  );
  const $monthlyTablet = $(
    ".".concat(
      containerName,
      "-container .payment-option",
      premium,
      "-monthly-tablet",
    ),
  );

  const isDesktop = $monthly.is(":visible") || $annual.is(":visible");

  const selectedPaymentPreference = getPaymentPeriod();

  if (selectedPaymentPreference === "annual") {
    if (isDesktop) {
      $monthly.hide();
      $annual.show();
    } else {
      $monthlyTablet.hide();
      $annualTablet.show();
    }
    localStorage.setItem("paymentPeriod", '"annual"');
  } else if (selectedPaymentPreference === "monthly") {
    if (isDesktop) {
      $annual.hide();
      $monthly.show();
    } else {
      $annualTablet.hide();
      $monthlyTablet.show();
    }
    localStorage.setItem("paymentPeriod", '"monthly"');
  }
}

function paymentPreference(prop) {
  if (prop) {
    return "annual";
  }
  return "monthly";
}

function toggleOptions() {
  // we have to refactor the premium in a separate PR
  togglePaymentOptions("toggle", "-premium");
  togglePaymentOptions("toggle");
  togglePaymentOptions("call-to-action");

  EventTracker.trigger("qdp_payment_toggle_clicked", getPaymentPeriod());
}

function getPaymentPeriod() {
  const paymentPreferenceToggle = $("#payment-preference-toggle");

  return paymentPreference(paymentPreferenceToggle.prop("checked"));
}

module.exports = {
  setPaymentToggleState,
};

$(".document-accordion").on("click", toggleSection);
$("#payment-preference-toggle").on("change", toggleOptions);

$(".document-accordion.logo").on("click", function () {
  const accordionText = $(this).find(".accordion-text");
  accordionText.toggleClass("hidden");

  const providerDetailsText = $(this)
    .closest(".provider-details__box")
    .find(".provider-details__text");
  providerDetailsText.toggleClass("hidden");
});
